import React from 'react';

import emotionsIcon from 'src/public/img/undraw-feeling-blue-4-b-7-q-copy.svg';
import thoughtsIcon from 'src/public/img/undraw-heartbroken-cble.svg';

import * as S from '../../stepComponents/styles';
import { CommonReactionsBox } from '../components/CommonReactionsBox';

const listEmotions = [
    'Anxiety and Fear',
    'Sadness, Grief, and Depression',
    'Anger and Irritability',
    'Disconnected, Withdrawn, Numb',
    'Lack of enjoyment',
    'Feeling empty or hopeless',
    'Shock',
];

const listThoughts = [
    'Difficulty concentrating or following instructions',
    'Memory problems or very strong memories of the events',
    'Recurring dreams or nightmares',
    'Trouble communicating',
];

export const CommonReactionsStep: React.SFC = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>Common Reactions you Might Experience</S.StepHeading>
                <S.StepDescription small>
                    There are common emotional, mental, and behavioral reactions after someone
                    experiences or witnesses a traumatic event. These can be difficult but usually
                    improve over time.
                </S.StepDescription>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow type="flex">
            <CommonReactionsBox
                isHorizontal={false}
                title="Emotions"
                icon={emotionsIcon}
                list={listEmotions}
            />
            <CommonReactionsBox
                isHorizontal={false}
                title="Thoughts"
                icon={thoughtsIcon}
                list={listThoughts}
            />
        </S.ContentRow>
    </>
);
